import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../../../core';
import { NegocioOportunidadeCreate } from '../negocio-oportunidade-create';
import { NegocioOportunidadeSearch } from '../negocio-oportunidade-search';

@Injectable({
    providedIn: 'root'
})
export class NegocioOportunidadeCreateHttpService {
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/crm/negociooportunidade`;
    }

    /** Cria um negócio a ser qualificado */
    create(create: NegocioOportunidadeCreate): Observable<NegocioOportunidadeSearch> {
        return this.customHttp.post<NegocioOportunidadeSearch>(this.pathApi, create);
    }
}
